import React, { useState } from "react";
import ProjectModuleApi from "../../api/ProjectModule";
import { showError, showSuccess } from "../../utils/toastUtils";

function AddDetails({ fetchModuleData }) {
  const [formData, setFormData] = useState({ module_name: "", estimated_hours: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await ProjectModuleApi.add(formData);
      if (res.code === 200) {
        showSuccess(res.message);
        setFormData({ module_name: "", estimated_hours: "" });
        fetchModuleData();
        document.getElementById("closeAddOffcanvas").click();
      }
    } catch (err) {
      showError(err.response?.data?.message || "Failed to add module");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="offcanvas-header border-bottom">
        <h5 className="fw-semibold">Add Project Module</h5>
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" id="closeAddOffcanvas" />
      </div>
      <div className="offcanvas-body">
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Module Name <span className="text-danger">*</span></label>
            <input
              type="text"
              className="form-control"
              required
              value={formData.module_name}
              onChange={(e) => setFormData({ ...formData, module_name: e.target.value })}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Estimated Hours <span className="text-danger">*</span></label>
            <input
              type="number"
              className="form-control"
              required
              value={formData.estimated_hours}
              onChange={(e) => setFormData({ ...formData, estimated_hours: e.target.value })}
            />
          </div>
          <button type="submit" className="btn btn-primary w-100" disabled={loading}>
            {loading ? "Saving..." : "Save Module"}
          </button>
        </form>
      </div>
    </>
  );
}

export default AddDetails;